export * from './app-sidebar-nav.component';



// WEBPACK FOOTER //
// /var/www/midac/midac-live/app/src/app/components/app-sidebar-nav/index.ts